module.exports = __webpack_public_path__ + "static/media/29FUNOV4.378ef21a.jpg";